export class Controller {

    /** @ngInject */
    constructor(RemoteAppAccessService) {
        this.RemoteAppAccessService = RemoteAppAccessService;
    }

    $onInit() {
    }

    remove() {
        this.isSaving = true;
        this.RemoteAppAccessService
            .remove(this.resolve.companyId, this.resolve.appId, this.resolve.remoteAppId)
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/remove/remove-remote-app.controller.js